export default __webpack_public_path__ + "static/media/Metropolis-SemiBold.5e856013.otf";